import React from 'react';
import { motion } from 'framer-motion';
export function StatsBar() {
  const stats = [{
    value: '50,000+',
    label: 'Homeowners Served'
  }, {
    value: '10,000+',
    label: 'Verified Professionals'
  }, {
    value: '4.8/5',
    label: 'Average Pro Rating'
  }, {
    value: '98%',
    label: 'Customer Satisfaction'
  }];
  return <section className="py-16 bg-slate-900 border-y border-slate-800" data-id="element-2763">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2764">
        <motion.div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-2765">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center" data-id="element-2766">
              <span className="text-3xl md:text-4xl font-extrabold text-white mb-2" data-id="element-2767">
                {stat.value}
              </span>
              <span className="text-sm md:text-base font-medium text-slate-400" data-id="element-2768">
                {stat.label}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}